export const ROOT_URL = process.env.NEXT_PUBLIC_URL;
export const ROOT_API_URL = process.env.NEXT_PUBLIC_API_URL;
